// hooks/useVerifyOtp.js
import { useState } from "react";
import { URLS } from "../config/url";

import { useNavigate } from "react-router-dom";

export const useVerifyOtp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const verifyOtp = async (email, otp) => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      const response = await fetch(`${URLS}/api/user/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp }),
      });

      const json = await response.json();

      if (!response.ok) {
        throw new Error(json.error || "OTP verification failed");
      }

      setMessage(json.message || "Email verified successfully!");
      // Clear the stored email after successful verification
      localStorage.removeItem("MyOtpemail");
      const accessTokenExpires = Date.now() + 3 * 60 * 1000; // 3 minutes in milliseconds
      localStorage.setItem("accessToken", json.accessToken);
      localStorage.setItem("refreshToken", json.refreshToken);
      localStorage.setItem("accessTokenExpires", accessTokenExpires.toString());
      localStorage.setItem("userEmail", json.email);
      // Navigate to login or home page after short delay
      setTimeout(() => navigate("/packages"), 2000);
    } catch (err) {
      setError(err.message || "An error occurred during OTP verification");
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    message,
    verifyOtp,
  };
};
